/* ==========================================================================
   Anfa Wen — product.js (product template only)
   Variant selection (radios + select fallback), media gallery, zoom modal,
   share copy, AJAX add-to-cart, related products via recommendations API.
   Loaded deferred from layout when request.page_type == 'product'.
   ========================================================================== */
(function () {
  'use strict';

  var AW = window.AnfaWen;

  /* ------------------------------------------------------------------
     Product form: variants
  ------------------------------------------------------------------ */
  var section = document.querySelector('[data-product-section]');

  if (section) {
    var form = section.querySelector('[data-product-form]');
    var selectWrapper = section.querySelector('[data-variant-select-wrapper]');
    var select = section.querySelector('[data-variant-select]');
    var radiosWrap = section.querySelector('[data-variant-picker]');
    var variants = [];
    try {
      variants = JSON.parse(section.querySelector('[data-variant-json]').textContent);
    } catch (e) {
      variants = [];
    }

    var priceWrap = section.querySelector('[data-price-wrapper]');
    var priceCurrent = section.querySelector('[data-price-current]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = addButton ? addButton.querySelector('.btn__label') : null;
    var skuValue = section.querySelector('[data-sku-value]');
    var skuWrap = section.querySelector('[data-sku]');
    var stockStatus = section.querySelector('[data-stock-status]');
    var waOrder = section.querySelector('[data-whatsapp-order]');
    var sticky = section.querySelector('[data-sticky-atc]');
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var stickyVariant = sticky ? sticky.querySelector('[data-sticky-variant]') : null;
    var stickyAdd = sticky ? sticky.querySelector('[data-sticky-add]') : null;

    function updateStock(variant) {
      if (!stockStatus) return;
      stockStatus.hidden = !variant || !variant.available;
      if (!variant || !variant.available) return;
      var threshold = Number(stockStatus.getAttribute('data-low-threshold')) || 0;
      var low = variant.inventory !== null && threshold > 0 && variant.inventory <= threshold;
      stockStatus.classList.toggle('stock-status--low', low);
      stockStatus.textContent = low
        ? (stockStatus.getAttribute('data-label-low') || '').replace('__COUNT__', variant.inventory)
        : stockStatus.getAttribute('data-label-in');
    }

    function updateWhatsApp(variant) {
      if (!waOrder || !variant) return;
      var title = waOrder.getAttribute('data-product-title') + (variants.length > 1 ? ' — ' + variant.title : '');
      var message = (waOrder.getAttribute('data-wa-template') || '')
        .replace('__TITLE__', title)
        .replace('__URL__', window.location.origin + variant.url);
      waOrder.href = 'https://wa.me/' + waOrder.getAttribute('data-wa-number') + '?text=' + encodeURIComponent(message);
    }

    function updateSticky(variant) {
      if (!sticky) return;
      if (stickyPrice && variant) stickyPrice.textContent = variant.price;
      if (stickyVariant && variant) stickyVariant.textContent = variant.title;
      if (stickyAdd && addButton) {
        stickyAdd.disabled = addButton.disabled;
        if (addLabel) stickyAdd.textContent = addLabel.textContent;
      }
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function selectedOptions() {
      var inputs = radiosWrap ? radiosWrap.querySelectorAll('input[type="radio"]:checked') : [];
      return Array.prototype.map.call(inputs, function (input) { return input.value; });
    }

    function activateMedia(mediaId) {
      if (!mediaId) return;
      var items = section.querySelectorAll('[data-media-item]');
      Array.prototype.forEach.call(items, function (item) {
        var active = item.getAttribute('data-media-id') === String(mediaId);
        var wasHidden = item.classList.contains('hidden');
        item.classList.toggle('hidden', !active);
        if (active && wasHidden) {
          item.classList.remove('is-entering');
          void item.offsetWidth;
          item.classList.add('is-entering');
        }
      });
      var thumbs = section.querySelectorAll('[data-thumb]');
      Array.prototype.forEach.call(thumbs, function (thumb) {
        var isActive = thumb.getAttribute('data-media-id') === String(mediaId);
        thumb.classList.toggle('is-active', isActive);
        if (isActive && thumb.parentNode.scrollWidth > thumb.parentNode.clientWidth) {
          thumb.parentNode.scrollTo({ left: thumb.offsetLeft - 12, behavior: 'smooth' });
        }
      });
    }

    function updateVariantUI(variant) {
      if (!variant) {
        if (addButton) {
          addButton.setAttribute('disabled', 'disabled');
          if (addLabel) addLabel.textContent = addButton.getAttribute('data-label-unavailable') || '';
        }
        updateStock(null);
        updateSticky(null);
        return;
      }
      if (select) select.value = String(variant.id);
      if (priceCurrent) priceCurrent.textContent = variant.price;
      if (priceWrap) {
        priceWrap.classList.toggle('price--on-sale', !!variant.compareAt);
        priceWrap.classList.toggle('price--sold-out', !variant.available);
      }
      if (priceCompare) {
        if (variant.compareAt) {
          priceCompare.textContent = variant.compareAt;
          priceCompare.removeAttribute('hidden');
          priceCompare.style.display = '';
        } else {
          priceCompare.setAttribute('hidden', 'hidden');
        }
      }
      if (AW && AW.updatePerPiece) AW.updatePerPiece(section.querySelector('.product__price'), variant.priceCents);
      var saveBadge = section.querySelector('[data-price-save]');
      if (saveBadge) {
        var save = variant.compareCents > variant.priceCents ? Math.floor((variant.compareCents - variant.priceCents) * 100 / variant.compareCents) : 0;
        saveBadge.hidden = save <= 0;
        if (save > 0) saveBadge.textContent = (saveBadge.getAttribute('data-template') || '').replace('__P__', save);
      }
      if (skuValue) skuValue.textContent = variant.sku || '';
      if (skuWrap) skuWrap.classList.toggle('hidden', !variant.sku);
      if (addButton) {
        if (variant.available) addButton.removeAttribute('disabled');
        else addButton.setAttribute('disabled', 'disabled');
        if (addLabel) {
          addLabel.textContent = variant.available
            ? addButton.getAttribute('data-label-available')
            : addButton.getAttribute('data-label-sold-out');
        }
      }
      updateStock(variant);
      updateWhatsApp(variant);
      updateSticky(variant);
      activateMedia(variant.mediaId);
      try {
        window.history.replaceState({}, '', variant.url);
      } catch (e) { /* ignore */ }
      markUnavailableValues();
      announce(variant);
    }

    /* Mark option values that cannot produce an available variant */
    function markUnavailableValues() {
      if (!radiosWrap) return;
      var groups = radiosWrap.querySelectorAll('.variant-option');
      Array.prototype.forEach.call(groups, function (group, groupIndex) {
        var inputs = group.querySelectorAll('input[type="radio"]');
        Array.prototype.forEach.call(inputs, function (input) {
          var hypothetical = [];
          Array.prototype.forEach.call(groups, function (g, gi) {
            var checked = g.querySelector('input[type="radio"]:checked');
            hypothetical.push(gi === groupIndex ? input.value : checked ? checked.value : null);
          });
          var existsAvailable = false;
          var existsAtAll = false;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var matches = true;
            for (var j = 0; j < hypothetical.length; j++) {
              if (hypothetical[j] === null || v.options[j] !== hypothetical[j]) { matches = false; break; }
            }
            if (matches) {
              existsAtAll = true;
              if (v.available) { existsAvailable = true; break; }
            }
          }
          /* Values stay clickable: a missing combination is resolved to the closest variant on change */
          var label = input.closest('.variant-option__value');
          if (label) {
            label.classList.toggle('variant-option__value--unavailable', existsAtAll && !existsAvailable);
            label.classList.toggle('variant-option__value--other', !existsAtAll);
          }
        });
      });
    }

    function cssEscape(value) {
      return String(value).replace(/["\\]/g, '\\$&');
    }

    function announce(variant) {
      var status = section.querySelector('[data-form-status]');
      if (status && variant) status.textContent = '';
    }

    /* Enhance: replace select with radio groups when JS is available */
    if (radiosWrap && variants.length > 0) {
      radiosWrap.removeAttribute('hidden');
      if (selectWrapper) selectWrapper.setAttribute('hidden', 'hidden');

      radiosWrap.addEventListener('change', function (event) {
        if (!event.target.matches('input[type="radio"]')) return;
        var group = event.target.closest('.variant-option');
        if (group) {
          var selectedLabel = group.querySelector('[data-option-selected-value]');
          if (selectedLabel) selectedLabel.textContent = event.target.value;
        }
        var variant = findVariant(selectedOptions());
        if (!variant && group) {
          /* Combination doesn't exist (e.g. White only in 30×50): keep the clicked value,
             take the closest variant (available first, then most shared options) and sync the other groups */
          var groupsList = Array.prototype.slice.call(radiosWrap.querySelectorAll('.variant-option'));
          var gi = groupsList.indexOf(group);
          var wanted = selectedOptions();
          var best = null;
          var bestScore = -1;
          variants.forEach(function (v) {
            if (v.options[gi] !== event.target.value) return;
            var score = (v.available ? 100 : 0);
            v.options.forEach(function (o, oi) { if (oi !== gi && o === wanted[oi]) score += 1; });
            if (score > bestScore) { best = v; bestScore = score; }
          });
          variant = best;
          if (variant) {
            groupsList.forEach(function (g, index) {
              var input = g.querySelector('input[value="' + cssEscape(variant.options[index]) + '"]');
              if (input) {
                input.checked = true;
                var label = g.querySelector('[data-option-selected-value]');
                if (label) label.textContent = variant.options[index];
              }
            });
          }
        }
        updateVariantUI(variant);
      });

      markUnavailableValues();
    }

    /* Select fallback (no radios e.g. single-option products still use radios; this covers direct select use) */
    if (select) {
      select.addEventListener('change', function () {
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === select.value) { variant = variants[i]; break; }
        }
        if (variant && radiosWrap) {
          var groups = radiosWrap.querySelectorAll('.variant-option');
          Array.prototype.forEach.call(groups, function (group, gi) {
            var input = group.querySelector('input[value="' + cssEscape(variant.options[gi]) + '"]');
            if (input) {
              input.checked = true;
              var selectedLabel = group.querySelector('[data-option-selected-value]');
              if (selectedLabel) selectedLabel.textContent = variant.options[gi];
            }
          });
        }
        updateVariantUI(variant);
      });
    }

    /* ----------------------------------------------------------------
       Sticky add-to-cart: shown while the main button is off screen,
       submits the real product form.
    ---------------------------------------------------------------- */
    if (sticky && addButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = hidden ? 0 : -1;
      }).observe(addButton);
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (!form || addButton.disabled) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(addButton);
          else addButton.click();
        });
      }
    }

    /* ----------------------------------------------------------------
       Gallery: thumbnails
    ---------------------------------------------------------------- */
    var thumbs = section.querySelectorAll('[data-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        activateMedia(thumb.getAttribute('data-media-id'));
      });
    });

    /* ----------------------------------------------------------------
       Gallery arrows + swipe on the main photo (RTL aware), counter
    ---------------------------------------------------------------- */
    var isRtl = document.documentElement.dir === 'rtl';
    var mediaItems = Array.prototype.slice.call(section.querySelectorAll('[data-media-item]'));
    var galleryCount = section.querySelector('[data-gallery-count]');
    function currentMediaIndex() {
      for (var i = 0; i < mediaItems.length; i++) if (!mediaItems[i].classList.contains('hidden')) return i;
      return 0;
    }
    function updateCount() {
      if (galleryCount) galleryCount.textContent = (currentMediaIndex() + 1) + ' / ' + mediaItems.length;
    }
    function stepMedia(delta) {
      if (mediaItems.length < 2) return;
      var next = (currentMediaIndex() + delta + mediaItems.length) % mediaItems.length;
      activateMedia(mediaItems[next].getAttribute('data-media-id'));
      updateCount();
    }
    updateCount();
    var galleryPrev = section.querySelector('[data-gallery-prev]');
    var galleryNext = section.querySelector('[data-gallery-next]');
    if (galleryPrev) galleryPrev.addEventListener('click', function () { stepMedia(-1); });
    if (galleryNext) galleryNext.addEventListener('click', function () { stepMedia(1); });
    /* Thumbnails and variant changes also move the photo: keep the counter in sync */
    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-thumb]')) window.setTimeout(updateCount, 0);
    });
    section.addEventListener('change', function () { window.setTimeout(updateCount, 0); });
    var viewport = section.querySelector('[data-media-viewport]');
    if (viewport) {
      var SWIPE_MIN = 45;
      var SWIPE_RATIO = 1.4;
      /* Shared by touch and mouse so both gestures step by the same rules. In RTL
         the next photo sits to the left, so the direction flips. data-swiped keeps
         the gesture from also opening the lightbox. */
      function commitGesture(dx, dy) {
        if (Math.abs(dx) <= SWIPE_MIN || Math.abs(dx) <= Math.abs(dy) * SWIPE_RATIO) return;
        viewport.setAttribute('data-swiped', '1');
        window.setTimeout(function () { viewport.removeAttribute('data-swiped'); }, 400);
        stepMedia((dx < 0 ? 1 : -1) * (isRtl ? -1 : 1));
      }

      var swipeX = null;
      var swipeY = null;
      viewport.addEventListener('touchstart', function (e) { swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (swipeX === null) return;
        var dx = e.changedTouches[0].clientX - swipeX;
        var dy = e.changedTouches[0].clientY - swipeY;
        swipeX = null;
        commitGesture(dx, dy);
      });

      /* Mouse and pen drag. Touch is left to the passive handlers above, so a
         single finger gesture is never counted twice. */
      var dragX = null;
      var dragY = null;
      var dragId = null;
      var dragCaptured = false;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        /* the arrows sit inside the viewport and keep their own clicks */
        if (e.target.closest('.gallery-nav')) return;
        dragX = e.clientX;
        dragY = e.clientY;
        dragId = e.pointerId;
        dragCaptured = false;
        viewport.classList.add('is-dragging');
      });
      viewport.addEventListener('pointermove', function (e) {
        if (dragId === null || e.pointerId !== dragId) return;
        if (Math.abs(e.clientX - dragX) <= 6) return;
        e.preventDefault();
        /* Capture only once this reads as a drag: capturing retargets the click,
           so a plain press must stay with the zoom button under the cursor. */
        if (!dragCaptured && viewport.setPointerCapture) {
          viewport.setPointerCapture(e.pointerId);
          dragCaptured = true;
        }
      });
      function endDrag(e) {
        if (dragId === null || e.pointerId !== dragId) return;
        var dx = e.clientX - dragX;
        var dy = e.clientY - dragY;
        dragX = null;
        dragY = null;
        dragId = null;
        dragCaptured = false;
        viewport.classList.remove('is-dragging');
        commitGesture(dx, dy);
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* ----------------------------------------------------------------
       Lightbox (native <dialog>): arrows, thumbnails, keyboard,
       zoom with buttons / wheel / double-click / pinch, drag to pan
    ---------------------------------------------------------------- */
    var zoomModal = section.querySelector('[data-zoom-modal]');
    var zoomImage = zoomModal ? zoomModal.querySelector('[data-zoom-image]') : null;
    var zoomButtons = Array.prototype.slice.call(section.querySelectorAll('[data-zoom-open]'));
    if (zoomModal && zoomImage && typeof zoomModal.showModal === 'function' && zoomButtons.length) {
      var stage = zoomModal.querySelector('[data-lightbox-stage]');
      var countEl = zoomModal.querySelector('[data-lightbox-count]');
      var levelEl = zoomModal.querySelector('[data-zoom-level]');
      var thumbsWrap = zoomModal.querySelector('[data-lightbox-thumbs]');
      var slides = zoomButtons.map(function (btn) {
        return { src: btn.getAttribute('data-zoom-src'), thumb: btn.getAttribute('data-zoom-thumb') || btn.getAttribute('data-zoom-src') };
      });
      var index = 0;
      var scale = 1;
      var tx = 0;
      var ty = 0;
      var MIN = 1;
      var MAX = 4;
      var STEP = 0.75;

      if (slides.length < 2) zoomModal.classList.add('lightbox--single');
      slides.forEach(function (slide, i) {
        var thumbBtn = document.createElement('button');
        thumbBtn.type = 'button';
        thumbBtn.className = 'lightbox__thumb';
        thumbBtn.setAttribute('aria-label', String(i + 1));
        var thumbImg = document.createElement('img');
        thumbImg.src = slide.thumb;
        thumbImg.alt = '';
        thumbImg.loading = 'lazy';
        thumbBtn.appendChild(thumbImg);
        thumbBtn.addEventListener('click', function () { show(i); });
        thumbsWrap.appendChild(thumbBtn);
      });

      function clampPan() {
        var rect = stage.getBoundingClientRect();
        var maxX = Math.max(0, (zoomImage.offsetWidth * scale - rect.width) / 2);
        var maxY = Math.max(0, (zoomImage.offsetHeight * scale - rect.height) / 2);
        tx = Math.max(-maxX, Math.min(maxX, tx));
        ty = Math.max(-maxY, Math.min(maxY, ty));
      }
      function apply(animate) {
        clampPan();
        zoomImage.style.transition = animate ? 'transform 260ms cubic-bezier(0.2, 0.7, 0.2, 1)' : 'none';
        zoomImage.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
        zoomModal.classList.toggle('is-zoomed', scale > 1.01);
        if (levelEl) levelEl.textContent = Math.round(scale * 100) + '%';
      }
      /* Zoom toward a screen point so what is under the cursor / fingers stays put */
      function zoomTo(next, clientX, clientY, animate) {
        next = Math.max(MIN, Math.min(MAX, next));
        var rect = stage.getBoundingClientRect();
        var cx = (clientX === undefined ? rect.left + rect.width / 2 : clientX) - (rect.left + rect.width / 2);
        var cy = (clientY === undefined ? rect.top + rect.height / 2 : clientY) - (rect.top + rect.height / 2);
        var ratio = next / scale;
        tx = cx - (cx - tx) * ratio;
        ty = cy - (cy - ty) * ratio;
        scale = next;
        if (scale === 1) { tx = 0; ty = 0; }
        apply(animate);
      }
      function show(i) {
        index = (i + slides.length) % slides.length;
        scale = 1;
        tx = 0;
        ty = 0;
        apply(false);
        zoomImage.classList.add('is-loading');
        zoomImage.onload = function () { zoomImage.classList.remove('is-loading'); };
        zoomImage.src = slides[index].src;
        if (countEl) countEl.textContent = (index + 1) + ' / ' + slides.length;
        Array.prototype.forEach.call(thumbsWrap.children, function (t, ti) { t.classList.toggle('is-active', ti === index); });
      }

      zoomButtons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          if (viewport && viewport.getAttribute('data-swiped')) return;
          show(i);
          zoomModal.showModal();
          document.documentElement.classList.add('lightbox-open');
        });
      });
      zoomModal.addEventListener('close', function () { document.documentElement.classList.remove('lightbox-open'); });
      zoomModal.querySelector('[data-zoom-close]').addEventListener('click', function () { zoomModal.close(); });
      zoomModal.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show(index - 1); });
      zoomModal.querySelector('[data-lightbox-next]').addEventListener('click', function () { show(index + 1); });
      zoomModal.querySelector('[data-zoom-in]').addEventListener('click', function () { zoomTo(scale + STEP, undefined, undefined, true); });
      zoomModal.querySelector('[data-zoom-out]').addEventListener('click', function () { zoomTo(scale - STEP, undefined, undefined, true); });
      zoomModal.querySelector('[data-zoom-reset]').addEventListener('click', function () { zoomTo(1, undefined, undefined, true); });
      zoomModal.addEventListener('keydown', function (e) {
        var forward = isRtl ? 'ArrowLeft' : 'ArrowRight';
        var back = isRtl ? 'ArrowRight' : 'ArrowLeft';
        if (e.key === forward) { e.preventDefault(); show(index + 1); }
        else if (e.key === back) { e.preventDefault(); show(index - 1); }
        else if (e.key === '+' || e.key === '=') zoomTo(scale + STEP, undefined, undefined, true);
        else if (e.key === '-') zoomTo(scale - STEP, undefined, undefined, true);
        else if (e.key === '0') zoomTo(1, undefined, undefined, true);
      });
      stage.addEventListener('wheel', function (e) {
        e.preventDefault();
        zoomTo(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY, false);
      }, { passive: false });
      stage.addEventListener('dblclick', function (e) {
        zoomTo(scale > 1.01 ? 1 : 2.5, e.clientX, e.clientY, true);
      });

      /* Pointer gestures: one pointer pans (or swipes when not zoomed), two pinch */
      var pointers = {};
      var startDist = 0;
      var startScale = 1;
      var lastX = 0;
      var lastY = 0;
      var downX = 0;
      var moved = false;
      stage.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button')) return;
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        stage.setPointerCapture(e.pointerId);
        var ids = Object.keys(pointers);
        if (ids.length === 2) {
          var p1 = pointers[ids[0]];
          var p2 = pointers[ids[1]];
          startDist = Math.hypot(p1.x - p2.x, p1.y - p2.y);
          startScale = scale;
        }
        lastX = downX = e.clientX;
        lastY = e.clientY;
        moved = false;
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pointers[e.pointerId]) return;
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(pointers);
        if (ids.length === 2) {
          var p1 = pointers[ids[0]];
          var p2 = pointers[ids[1]];
          if (startDist > 0) zoomTo(startScale * Math.hypot(p1.x - p2.x, p1.y - p2.y) / startDist, (p1.x + p2.x) / 2, (p1.y + p2.y) / 2, false);
          moved = true;
          return;
        }
        if (Math.abs(e.clientX - downX) > 4) moved = true;
        if (scale > 1.01) {
          tx += e.clientX - lastX;
          ty += e.clientY - lastY;
          apply(false);
        }
        lastX = e.clientX;
        lastY = e.clientY;
      });
      function endPointer(e) {
        if (!pointers[e.pointerId]) return;
        delete pointers[e.pointerId];
        if (Object.keys(pointers).length === 0 && scale <= 1.01) {
          var dx = e.clientX - downX;
          if (Math.abs(dx) > 60) show(index + (dx < 0 ? 1 : -1) * (isRtl ? -1 : 1));
          /* A plain click on the backdrop (not the photo) closes */
          else if (!moved && e.target === stage) zoomModal.close();
        }
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
      window.addEventListener('resize', function () { if (zoomModal.open) apply(false); });
    }

    /* ----------------------------------------------------------------
       Share: copy link
    ---------------------------------------------------------------- */
    Array.prototype.forEach.call(section.querySelectorAll('[data-copy-link]'), function (btn) {
      btn.addEventListener('click', function () {
        var done = function () {
          var original = btn.getAttribute('aria-label');
          var copied = btn.getAttribute('data-copied-label') || '';
          btn.setAttribute('aria-label', copied);
          window.setTimeout(function () { btn.setAttribute('aria-label', original); }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href).then(done, done);
        } else {
          done();
        }
      });
    });

    /* ----------------------------------------------------------------
       AJAX add to cart (native POST remains the no-JS fallback)
    ---------------------------------------------------------------- */
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        var status = section.querySelector('[data-form-status]');
        if (addButton) {
          addButton.setAttribute('aria-busy', 'true');
          addButton.setAttribute('disabled', 'disabled');
        }
        fetch(form.getAttribute('action') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            return AW.getJSON('/cart.js');
          })
          .then(function (cart) {
            if (status) {
              status.textContent = status.getAttribute('data-msg-added') || '';
            }
            if (AW && AW.updateCartCount) AW.updateCartCount(cart.item_count);
            if (AW && AW.openCartAfterAdd) AW.openCartAfterAdd();
          })
          .catch(function (error) {
            if (status) {
              status.textContent = (error && (error.description || error.message)) || status.getAttribute('data-msg-error') || '';
              status.classList.add('form__message--error');
            }
          })
          .then(function () {
            if (addButton && !addButton.getAttribute('data-force-disabled')) {
              addButton.removeAttribute('aria-busy');
              var currentVariant = findVariant(selectedOptions());
              if (!currentVariant || currentVariant.available) addButton.removeAttribute('disabled');
            }
          });
      });
    }
  }

  /* ------------------------------------------------------------------
     Recently viewed: stored in this browser only, rendered as simple cards
  ------------------------------------------------------------------ */
  var recent = document.querySelector('[data-recently-viewed]');
  if (recent) {
    var storeKey = 'aw-recently-viewed';
    var limit = Number(recent.getAttribute('data-limit')) || 4;
    var current = {
      handle: recent.getAttribute('data-handle'),
      title: recent.getAttribute('data-title'),
      url: recent.getAttribute('data-url'),
      image: recent.getAttribute('data-image'),
      price: recent.getAttribute('data-price')
    };
    var saved = [];
    try { saved = JSON.parse(window.localStorage.getItem(storeKey)) || []; } catch (e) { saved = []; }
    if (!Array.isArray(saved)) saved = [];
    var others = saved.filter(function (item) {
      return item && item.handle && item.handle !== current.handle &&
        typeof item.url === 'string' && /^\/(?!\/)/.test(item.url) &&
        (!item.image || /^(https:)?\/\//.test(item.image));
    });
    try {
      window.localStorage.setItem(storeKey, JSON.stringify([current].concat(others).slice(0, 12)));
    } catch (e) { /* storage unavailable: feature simply stays off */ }

    var list = recent.querySelector('[data-recently-viewed-list]');
    if (list && others.length) {
      others.slice(0, limit).forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'product-card';
        var media = document.createElement('a');
        media.className = 'product-card__media media media--portrait';
        media.href = item.url;
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        }
        var info = document.createElement('div');
        info.className = 'product-card__info';
        var title = document.createElement('h3');
        title.className = 'product-card__title';
        var link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        title.appendChild(link);
        var price = document.createElement('p');
        price.className = 'price__current';
        price.textContent = item.price || '';
        info.appendChild(title);
        info.appendChild(price);
        li.appendChild(media);
        li.appendChild(info);
        list.appendChild(li);
      });
      recent.hidden = false;
    }
  }

  /* ------------------------------------------------------------------
     Related products: fetch section via recommendations API
  ------------------------------------------------------------------ */
  var related = document.querySelector('[data-related-products]');
  if (related) {
    var relatedUrl = related.getAttribute('data-related-url');
    if (relatedUrl && window.fetch) {
      fetch(relatedUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('recommendations failed');
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var rendered = doc.querySelector('[data-related-products]');
          if (rendered && rendered.innerHTML.trim()) {
            related.innerHTML = rendered.innerHTML;
          }
        })
        .catch(function () { /* section simply stays hidden */ });
    }
  }
})();
